import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { observer } from 'mobx-react-lite';
import { ApplicationSdk } from '../../stores';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import { Divider } from 'primereact/divider';

const CategoryFilter = observer(({ store }: { store: any }) => {
    return (
        <div className="p-inputgroup flex-1">
            <InputText placeholder="Kategorien durchsuchen" value={store.quickSearch} onChange={(e) => store.quickSearch = e.target.value} />
        </div>
    );
});
const CategoryDeleteButton = observer(({ rowData, store, onDelete }: { rowData: any, store: any, onDelete: any }) => {
    return (
        <div style={{ textAlign: 'right' }}>
            <Button
                className="p-button-danger"
                icon={'pi pi-trash'}
                loading={store.categoryDeleteLoading}
                onClick={() => onDelete(rowData.id, rowData.name)}
            />
        </div>
    );
});

const CategoryDialog = observer(({ sdk }: { sdk: ApplicationSdk }) => {
    const store = sdk.currentDialog;


    const confirmDelete = (categoryId: number, name: string) => {
        confirmDialog({
            message: `Sind Sie sicher, dass Sie die Kategorie '${name}' löschen möchten? Produkte die dieser Kategorie zugeordnet sind, haben dann keine Kategorie mehr`,
            header: 'Bestätigung',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                try {
                    await store.deleteCategory(categoryId);
                    sdk.showSuccessToast('Kategorie gelöscht');
                } catch(e) {
                    sdk.showErrorToast(`Ein Fehler ist aufgetreten`);
                }
            },
            reject: () => { }
        });
    };

    const handleCreateNewCategory = async () => {
        try {
            await store.createNewCategory();
            sdk.showSuccessToast('Kategorie angelegt');
        } catch (error: any) {
            let reason: string = 'Unbekannter Fehler';
            if (error?.message === 'CATEGORY_ALREADY_EXISTS') {
                reason = 'Die Kategorie ist bereits vorhanden!'
            }
            sdk.showErrorToast(`${reason}`)
        }
    };

    return (
        <Dialog
            visible={!!sdk.currentDialog}
            modal
            header="Kategorie bearbeiten"
            footer={null}
            style={{ width: '50rem', height: '50rem', maxWidth: 512, }}
            onHide={() => sdk.closeDialog()}
        >
            <div className="p-fluid">
                <div className="p-field" style={{ display: 'flex', alignItems: 'center' }}>
                    <InputText
                        id="newCategory"
                        value={store.newCategoryName}
                        placeholder="Neue Kategorie"
                        onChange={(e) => store.newCategoryName = e.target.value}
                        style={{ flex: '2', marginRight: '1rem' }}
                    />
                    <Button
                        onClick={handleCreateNewCategory}
                        icon={'pi pi-plus'}
                        disabled={!store.newCategoryName}
                        loading={store.categoryNewLoading}
                    />
                </div>
                <Divider />
                {store.categoryDataLoading ? (
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
                        <ProgressSpinner />
                    </div>
                ) : (
                    <div style={{ marginTop: '1rem' }}>
                        <CategoryFilter store={store} />
                        <DataTable value={store.allCategories} style={{ marginTop: '1rem' }}>
                            <Column field="name" header="Kategorie" />
                            <Column
                                body={(rowData: any) => (
                                    <CategoryDeleteButton rowData={rowData} store={store} onDelete={(id: any, name: string) => confirmDelete(id, name)} />
                                )}
                            />
                        </DataTable>
                    </div>
                )}
            </div>
            <ConfirmDialog style={{ maxWidth: 512 }} />
        </Dialog>
    );
});

export default CategoryDialog;